import React, { Fragment } from "react";

import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { defineMessages, IntlShape } from "react-intl";

import styles from "./UpsellBulletPoints.module.scss";

const messages = defineMessages({
  purchaseBulletPoint1: {
    id: "leadFinder.upsellBulletPoints.points.1",
    defaultMessage: "Find new leads by location",
    description: "Lead Finder bullet points",
  },
  purchaseBulletPoint2: {
    id: "leadFinder.upsellBulletPoints.points.2",
    defaultMessage: "Add companies directly from the map",
    description: "Lead Finder bullet points",
  },
  purchaseBulletPoint3: {
    id: "leadFinder.upsellBulletPoints.points.3",
    defaultMessage: "Sync new companies back to your CRM",
    description: "Lead Finder bullet points",
  },
  purchaseBulletPoint4: {
    id: "leadFinder.upsellBulletPoints.points.4",
    defaultMessage: "Extra data like hours, site, and contact info",
    description: "Lead Finder bullet points",
  },
});

const bulletPointMessages = [
  messages.purchaseBulletPoint1,
  messages.purchaseBulletPoint2,
  messages.purchaseBulletPoint3,
  messages.purchaseBulletPoint4,
];

export interface UpsellBulletPointsProps {
  className?: string;
  // this component might be used out of contexts scope, e.g. in showLeadFinderUpsell function
  intl: IntlShape;
}

const UpsellBulletPoints = ({ className, intl }: UpsellBulletPointsProps) => {
  return (
    <div className={cn(styles.container, className)}>
      {bulletPointMessages.map((message) => (
        <Fragment key={message.id}>
          <FontAwesomeIcon className={styles.checkIcon} icon={faCircleCheck} />
          <div>{intl.formatMessage(message)}</div>
        </Fragment>
      ))}
    </div>
  );
};

export default UpsellBulletPoints;
